<template>
  <component :is="layoutComponent" />
</template>

<script>
import { defineAsyncComponent } from 'vue'

export default {
  name: 'DynamicConsumerLayout',
  computed: {
    layoutComponent () {
      const layout = this.$route.meta.layout
      if (!layout || layout === 'ConsumerLayout') {
        return defineAsyncComponent(() => import(/* webpackChunkName: "consumer-layout-ConsumerLayout" */ 'src/modules/consumer/layouts/ConsumerLayout.vue'))
      } else if (layout === 'PlainLayout') {
        return defineAsyncComponent(() => import(/* webpackChunkName: "auth-layout-PlainLayout" */ 'src/modules/auth/layouts/PlainLayout.vue'))
      }

      // Default to file name matching layout
      return defineAsyncComponent(() => import(/* webpackChunkName: "consumer-layout-[request]" */ 'src/modules/consumer/layouts/' + layout + '.vue'))
    }
  },
  configuration: ['currentSite'],
  watch: {
    'currentSite.id': {
      handler () {
        this.setBodySiteIdClass()
      },
      immediate: true
    }
  },
  methods: {
    setBodySiteIdClass () {
      if (!this.currentSite) return

      const previousSiteBodyClass = _.find(document.body.classList, classname => _.startsWith(classname, 'site-'))
      if (previousSiteBodyClass) {
        document.body.classList.remove(previousSiteBodyClass)
      }
      document.body.classList.add(`site-${this.currentSite.id}`)
    }
  }
}
</script>
